import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { CommonService } from 'src/app/_services/common.service';
import { AlertService } from 'src/app/_helpers/alert.service';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ForgotPasswordComponent implements OnInit {

  showLoader:boolean = false;

  @ViewChild('forgotPasswordNgForm') forgotPasswordNgForm!: NgForm;
  forgotPasswordForm: FormGroup = this._formBuilder.group({
    email : ['', [
      Validators.required,
      Validators.email,
      Validators.pattern(this._commonService.emailRegex)
    ]],
  });

  constructor(
    private _title: Title,
    private _router: Router,
    private _formBuilder: FormBuilder,
    private _commonService: CommonService,
    private _alertService: AlertService,
    private _authService: AuthService,
  ) {
    this._title.setTitle('Forgot Password');
  }

  ngOnInit(): void {
    
  }

  forgotPassword(): void {
    // Return if the form is invalid
    if (this.forgotPasswordForm?.invalid) {
      return;
    }

    this.showLoader = true;
    this._authService.forgotPassword(this.forgotPasswordForm.value).subscribe({
      next: (response: any) => {
        const { isSuccess, message } = response;
        this.showLoader = false;
        this._alertService.show_alert(response?.message);
        this._router.navigate(['/reset-password']);
      },
      error: (errorResponse) => {
        this.showLoader = false;
        this._alertService.show_alert(errorResponse?.message, '', 'error');
      }
    });
  }

}
